import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { EntityAuditEvent } from './entity-audit-event.model';
import { DateUtils } from 'ng-jhipster';
import {Candidature} from "../candidature/candidature.model";
@Injectable()
export class EntityAuditEventService {

    private resourceUrl = 'api/entity-audit-events';
    private resourceLogCandidatureUrl = 'api/entity-audit-events/candidatureFormation';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    find(id: number): Observable<EntityAuditEvent> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.modifiedDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.modifiedDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    findLogCandidatureFormation(idCandidatureFormation?: number): Observable<Response> {
        return this.http.get(this.resourceLogCandidatureUrl + "/" + idCandidatureFormation)
            .map((res: any) => this.convertResponse(res))  ;
    }


    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].modifiedDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].modifiedDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }



}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event.service.ts